<label *ngIf="value" class="o-label" [ngClass]="config.cssClassesValue">{{ value }}</label>
